/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IAclEntry {
        identityId: number;
        identityClass: string; 
        type: string;
        read: boolean;
        write: boolean;
        group?: number;
        groupName: string;
        role?: string;
        organizationId?: number;
    }

    export interface IEvaluatedAcl {
        read: boolean;
        write: boolean;
        gui: boolean;
        organizations: number[];
    }

    export interface IAclEntries {
        aclEntries: AclEntry[];
        identityClass: string;
        identityId: number;
    }

    export class AclEntry implements IAclEntry {
        public identityId: number;
        public identityClass: string; 
        public type: string;
        public read: boolean;
        public write: boolean;
        public canAccessGui: boolean;
        public group: number;
        public role: string;
        public groupName: string;
        public organizationId: number;
        public translatedType?: string;
        public translatedRole?: string;

        public static Empty(): AclEntry {
            return new AclEntry();
        }

        public static addGroupAclEntry(aclEntries: IAclEntries, selectedGroup: Application.Models.IUserGroup): AclEntry {
            let groupAclEntry: AclEntry = new AclEntry();
            groupAclEntry.group = selectedGroup.id as number;
            groupAclEntry.groupName = selectedGroup.name;
            groupAclEntry.identityClass = aclEntries.identityClass;
            groupAclEntry.identityId = aclEntries.identityId;
            groupAclEntry.type = 'Group';
            aclEntries.aclEntries.push(groupAclEntry);
            return groupAclEntry;
        }

        public static sortAclEntries(acls: AclEntry[]): AclEntry[] {
            return acls.sort((a: AclEntry, b: AclEntry) => {
                if (a.type === 'Owner')
                    return -1;
                else if (b.type === 'Owner')
                    return 1;
                else if (a.type === 'Others')
                    return 1;
                else if (b.type === 'Others')
                    return -1;
                else if (a.type === 'Group' && b.type === 'Role')
                    return -1;
                else if (b.type === 'Group' && a.type === 'Role')
                    return -1;
                else
                    return -1;
            });
        }

        constructor() {
            // empty constructor
            this.read = false;
            this.write = false;
            this.group = undefined;
            this.role = undefined;
        }
    }

    export interface IWebApplicationPermission {
        name: string;
        id: number;
        aclEntry: Models.AclEntry;
    }

    export class WebApplications {
        public static getWebApplications(isMonitoringOnly?: boolean): IWebApplicationPermission[] {
            let webApps: IWebApplicationPermission[] =  [
                { id: 1, name: "Monitoring Room" , aclEntry: new AclEntry() },
                { id: 2, name: "Matrix Room" , aclEntry: new AclEntry() },
                { id: 3, name: "Network Map" , aclEntry: new AclEntry() },
                { id: 4, name: "Support Toolkit" , aclEntry: new AclEntry() },    // previously Network Nodes
            //  { id: 5, name: "Mobile data" , aclEntry: new AclEntry() },
            //  { id: 6, name: "Recordings & Exports" , aclEntry: new AclEntry() },
                { id: 7, name: "Device Map" , aclEntry: new AclEntry() },
                { id: 8, name: "Connection room" , aclEntry: new AclEntry() },
                { id: 9, name: "Admin Alarms" , aclEntry: new AclEntry() },
                { id: 10, name: "Admin Users" , aclEntry: new AclEntry() },
                { id: 11, name: "Admin Groups" , aclEntry: new AclEntry() },
                { id: 14, name: "Multiviewer room" , aclEntry: new AclEntry() },
                { id: 21, name: "Alarms console" , aclEntry: new AclEntry() },
            ];
            return !isMonitoringOnly ? webApps : this.filterOutMatrixRoom(webApps);
        }

        public static getVnoWebApplications(isMonitoringOnly?: boolean): IWebApplicationPermission[] {
            let webApps: IWebApplicationPermission[] =  [
                { id: 1, name: "Monitoring Room" , aclEntry: new AclEntry() },
                { id: 2, name: "Matrix Room" , aclEntry: new AclEntry() },
                { id: 3, name: "Network Map" , aclEntry: new AclEntry() },
                { id: 4, name: "Support Toolkit" , aclEntry: new AclEntry() },      // previously Network Nodes
                { id: 8, name: "Connection room" , aclEntry: new AclEntry() },
                { id: 14, name: "Multiviewer room" , aclEntry: new AclEntry() },
                { id: 21, name: "Alarms console" , aclEntry: new AclEntry() },
            ];
            return !isMonitoringOnly ? webApps : this.filterOutMatrixRoom(webApps);
            
        }
        public static filterOutMatrixRoom(webApps: IWebApplicationPermission[]): IWebApplicationPermission[] {
            return webApps.filter((webApp: IWebApplicationPermission) => {
                return webApp.id !== 2;
            });
        }
    }

    // export const webApplications: IWebApplicationPermission[] = [
    //     { id: 1, name: "Monitoring Room" , aclEntry: new AclEntry() },
    //     { id: 2, name: "Matrix Room" , aclEntry: new AclEntry() },
    //     { id: 3, name: "Topology Manager" , aclEntry: new AclEntry() },
    //     { id: 4, name: "Support Tool" , aclEntry: new AclEntry() },
    //     { id: 5, name: "Mobile data" , aclEntry: new AclEntry() },
    //     { id: 6, name: "Recordings & Exports" , aclEntry: new AclEntry() },
    //     { id: 7, name: "Device Map" , aclEntry: new AclEntry() },
    //     { id: 8, name: "Connection room" , aclEntry: new AclEntry() },
    //     { id: 9, name: "Admin Alarms" , aclEntry: new AclEntry() },
    //     { id: 10, name: "Admin Users" , aclEntry: new AclEntry() },
    //     { id: 11, name: "Admin Groups" , aclEntry: new AclEntry() },
    //     { id: 14, name: "Multiviewer room" , aclEntry: new AclEntry() },
    // ];
}
